import { render, staticRenderFns } from "./exam-reg-info.vue?vue&type=template&id=139f4b12"
import script from "./exam-reg-info.vue?vue&type=script&lang=js"
export * from "./exam-reg-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports